import { getRuntimeViteEnv } from "../runtimeEnv";

/** Averer replaces Dynamic as the signing wallet only when explicitly selected. */
export const isAvererWalletSelected = (): boolean => getRuntimeViteEnv("VITE_WALLET_PROVIDER") === "averer";
